// Comment this if you want to be developing with the production DB
let ROOT_URL = "";
let APP_ID = "839208706257167";
if (process.env.NODE_ENV === "production") {
  ROOT_URL = "https://frankie-backend.voltic.xyz";
} else {
  ROOT_URL = "https://test.frankie.tech";
  APP_ID = "1521851261194538"; // Use this token on development or testing (If using the local server)
}

export { ROOT_URL, APP_ID };



// WEBPACK FOOTER //
// ./src/redux/config/global.js